import { Form, Modal } from 'react-bootstrap'
import './Success_Modal.css'
import Green_Check_Lottie from '../../../animation/green_check_lottie/Green_Check_Lottie';

const Success_Modal = (props) => {

    // setTimeout(() => {
    //     props?.onHide()
    // }, 3000);

    return (
        <Modal className="Success_Modal" size='sm' {...props} centered>

            <Modal.Header closeButton>
                    <div className="logo_holder">
                      <img src="/assets/images/header/header_logo2.png" className="logo_img" />
                    </div>
                  </Modal.Header>

            <Modal.Body>
                <p className='success_text'>{props?.successText}</p>
            </Modal.Body>


        </Modal>
    )
}

export default Success_Modal
